













































































































































import { Guid } from "guid-typescript";
import { cloneDeep } from "lodash";
import Vue from "vue";
import { Component, Emit, Prop, VModel } from 'vue-property-decorator';
import draggable from 'vuedraggable'

import { reflectChipsValues, reflectedStringToList } from "../Chips/logic/reflectChipsValues";
import Icon from "../Icon/Icon.vue";
import AddChipButton from "./components/AddChipButton.vue";
import ChipSettingModal from "./components/ChipSettingModal.vue";
import ChipsList from "./components/ChipsList.vue";
import {
  ModalAction,
  PossibleChipTypeInfo,
  RawChipItem,
  RawFrontendChipItem
} from "./typedChips.types";
import {
  chipExistsByStruct,
  defaultTypeOrFirst,
  firstFiveSlicedValues,
  frontendChips,
  frontendChipTemplate,
  rawChips,
  removeChip,
  updateChip
} from "./typedChipsLogic";

@Component({
  components: {
    Icon,
    AddChipButton,
    ChipSettingModal,
    ChipsList,
    draggable
  },
})
export default class TypedChips extends Vue {
  @VModel({ type: Array, required: true, default: () => [] }) model!: Array<RawChipItem>

  @Prop({ type: Object, required: true  }) possibleChipTypeInfos!: PossibleChipTypeInfo

  @Prop({ type: Boolean, required: false, default: false }) draggable!: boolean

  @Prop({ type: Boolean, required: false, default: false }) disabled!: boolean

  @Prop() prefix!: string

  @Emit()
  change(items: Array<RawChipItem>) {
    return items
  }

  get frItems() {
    return frontendChips(this.model, this.possibleChipTypeInfos)
  }

  set frItems(val: Array<RawFrontendChipItem>) {
    this.change(rawChips(val))
  }

  modalAction = ModalAction.new

  modal = false

  currentTab = 1

  textAreaModel = ''

  filterInputText = ''

  newCurrentItem: RawFrontendChipItem | null = null

  get queriedItems() {
    if (this.filterInputText.length) {
      return this.frItems.filter(i => i.model && i.model.value.trim().toLowerCase().includes(this.filterInputText.trim().toLowerCase()))
    }

    return this.frItems
  }

  get shortItems() {
    return `${ firstFiveSlicedValues(this.frItems).join(', ') }...`
  }

  get tabBarStyle(): Partial<CSSStyleDeclaration> {
    const baseStyles: Partial<CSSStyleDeclaration> = {
      display: 'flex'
    }

    if (!this.$screen.md) {
      return Object.assign(baseStyles, {
        flexDirection: 'column-reverse',
        order: '1'
      })
    }

    return Object.assign(baseStyles, {
      alignItems: 'center',
      flexDirection: 'row-reverse',
      justifyContent: 'space-between'
    })
  }

  onTabChange(key: number) {
    if (key === 2) {
      this.processItemsToTextArea()
    }
  }

  onBlur() {
    this.frItems = reflectedStringToList(this.textAreaModel)
      .filter(v => v.trim().length)
      .reduce<Array<RawFrontendChipItem>>((acc, value) => {
        const info = Object.entries(this.possibleChipTypeInfos).find(([ _, config ]) => value.startsWith(config.prefix ?? ''))
        let template = frontendChipTemplate(this.possibleChipTypeInfos)

        if (info) {
          const [ type, config ] = info

          if (template.model) {
            template.model.value = value.replace(config.prefix ?? '', '');
            template.model[config.typeKey] = type
          }

          template.info = config;
        } else {
          if (template.model) {
            template.model.value = value.replace(template.info?.prefix ?? '', '')
          }
        }

        acc.push(template)

        return acc
      }, [])
  }

  processItemsToTextArea() {
    this.textAreaModel = this.frItems
      .map((item) => {
        if (item.model) {
          return reflectChipsValues(item.info?.prefix, item.model.value)
        }
      })
      .filter(i => !!i)
      .join(', ')
  }

  onAddChipClick() {
    const { type, config } = defaultTypeOrFirst(this.possibleChipTypeInfos)

    this.newCurrentItem = {
      info: config,
      type: type,
      model: null,
    }

    this.modalAction = ModalAction.new
    this.modal = true
  }

  selectChip(chip: RawFrontendChipItem) {
    if (chip.info) {
      this.newCurrentItem = cloneDeep(chip)

      this.modalAction = ModalAction.edit
      this.modal = true;
    }
  }

  addChip(item: RawFrontendChipItem) {
    if (item) {
      if (!item.guid) {
        if (Array.isArray(item.model)) {
          const chips = [ ...this.frItems ]

          item.model.forEach(i => {
            if (!chipExistsByStruct(this.frItems, i)) {
              chips.push({
                guid: Guid.create().toString(),
                model: i,
                info: item.info,
                type: item.type
              })
            }
          })

          this.frItems = [ ...chips ]
        }
      } else {
        this.frItems = updateChip(this.frItems, item)
      }
    }

    this.modal = false
  }

  onTagRemove(tagGuid: string) {
    this.frItems = removeChip(this.frItems, tagGuid)
  }
}
